<template>
    <hts-router-drawer
        ref="openRouterView"
        :rules="ruleAddCustomer"
        :submit="visibleSubmit"
        :title="$t('labels.partnerEdit')"
        no-reset
        size="large"
        @loaded="getData">
        <div v-loading="loading">
            <hts-card :title="$t('labels.generalInformation')">
                <hts-form-input
                    v-model="dataFormEdit.name"
                    :label="$t('labels.companyName')"
                    required
                    :color="props.color"
                    name="companyName"
                    prop="name" />
                <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                    <hts-form-input
                        v-model="dataFormEdit.abbreviationName"
                        :label="$t('labels.abbreviationName')"
                        :color="props.color"
                        name="abbreviationName"
                        prop="abbreviationName" />
                    <hts-form-input
                        v-model="dataFormEdit.taxNumber"
                        :label="$t('labels.taxNumber')"
                        :color="props.color"
                        name="taxNumber"
                        prop="taxNumber"
                        required />

                    <hts-form-input
                        v-model="dataFormEdit.email"
                        :label="$t('labels.email')"
                        :color="props.color"
                        name="email"
                        prop="email" />
                    <hts-form-phone
                        v-model="dataFormEdit.phone"
                        :label="$t('labels.phone')"
                        prop="phone"
                        name="phone"
                        @updateCode="(val) => (dataFormEdit.phone.code = val)" />
                    <hts-form-input
                        v-model="dataFormEdit.representation"
                        :label="$t('labels.representation')"
                        :color="props.color"
                        name="representation"
                        prop="representation" />
                    <hts-form-input
                        v-model="dataFormEdit.office"
                        :label="$t('labels.office')"
                        :color="props.color"
                        name="office"
                        prop="office" />
                    <hts-form-input
                        v-model="dataFormEdit.website"
                        :label="$t('labels.website')"
                        :color="props.color"
                        name="website"
                        prop="website" />
                    <hts-form-input
                        v-model="dataFormEdit.fax"
                        :label="$t('labels.fax')"
                        :color="props.color"
                        name="fax"
                        prop="fax" />
                    <hts-form-input
                        v-model="dataFormEdit.address"
                        :label="$t('labels.address')"
                        :color="props.color"
                        name="address"
                        prop="address"
                        @change="setDefaultDataPostionByAddress" />
                    <hts-form-input
                        v-model="dataFormEdit.locationName"
                        :label="$t('labels.location')"
                        :color="props.color"
                        name="location"
                        prop="location"
                        required
                        autocomplete="off"
                        @click="openModalLocation" />

                    <div
                        v-if="
                            (dataFormEdit.type?.includes('PARTNER') || dataFormEdit.type?.includes('CUSTOMER')) &&
                                selectCustomerTypeTabs &&
                                !dataFormEdit.sentInviteJoinSystem &&
                                !dataFormEdit.workspaceCustomer
                        "
                        class="my-5">
                        <hts-form-toggle
                            v-model="dataFormEdit.isSendMail"
                            :label="$t('labels.isSendEmail')"
                            color="primary"
                            label-right />
                        <hts-form-input
                            v-if="dataFormEdit.isSendMail"
                            v-model="dataFormEdit.emailInvite"
                            :label="$t('labels.emailInvite')"
                            required
                            :color="props.color"
                            name="emailInvite"
                            prop="emailInvite"
                            @change="emailInviteError = ''" />
                        <p
                            v-if="emailInviteError && dataFormEdit.isSendMail"
                            class="text-error-500 text-xs pl-2 pt-1">
                            {{ emailInviteError }}
                        </p>
                    </div>
                </div>
            </hts-card>

            <hts-card :title="$t('labels.typeCustomer')">
                <div>
                    <div class="flex">
                        <hts-form-checkbox
                            v-model="dataFormEdit.type"
                            :label="$t('labels.typeCustomer')"
                            :items="selectCooperatorTypes"
                            required
                            prop="typeCustomer"
                            name="typeCustomer"
                            :disabled="haveJoinSystem" />
                    </div>
                    <p
                        v-if="haveJoinSystem"
                        class="text-warning-500">
                        Người dùng đã tham gia vào hệ thống/khách hàng được kết nối không thể thay đổi loại công ty.
                    </p>
                </div>
                <hts-form-button-group
                    v-if="customerTypeTabs && customerTypeTabs.length"
                    v-model="selectCustomerTypeTabs"
                    :items="customerTypeTabs"
                    type="button"
                    class="my-5" />

                <div
                    v-if="dataFormEdit.type.includes('CUSTOMER') && selectCustomerTypeTabs"
                    v-show="selectCustomerTypeTabs === 'CUSTOMER'"
                    class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                    <hts-form-input
                        v-model="dataFormEdit.markup"
                        content-tooltip-disabled="Markup đang chờ được confirm"
                        :disabled="!dataFormEdit.statusMarkup && dataFormEdit.statusConfirmMarkup === 0 && oldTypes.includes('CUSTOMER')"
                        :label="$t('labels.markupPercent')"
                        :color="props.color"
                        type="number"
                        required
                        name="markupPercent"
                        prop="markup" />
                    <div
                        v-if="oldTypes.includes('CUSTOMER')"
                        class="flex items-center pt-6">
                        <div
                            v-if="!dataFormEdit.statusMarkup && dataFormEdit.statusConfirmMarkup === 0 && checkPermission(layoutPermissions.partner_confirm_status_markup)"
                            class="flex">
                            <hts-tooltip
                                :content="tooltipMarkup"
                                class="flex px-1 items-center">
                                <template #reference>
                                    <hi-exclamation-circle-icon
                                        class="w-7 h-7 text-orange-600"
                                        aria-hidden="true" />
                                </template>
                            </hts-tooltip>
                            <div>
                                <div
                                    class="flex cursor-pointer"
                                    @click="handleShowPopupConfirmStatusMarkup">
                                    <span class="">
                                        {{ $t('labels.approve') }}
                                    </span>
                                    <hi-check-circle-icon
                                        class="w-5 h-5 text-blue-600"
                                        aria-hidden="true" />
                                </div>
                                <div
                                    class="flex cursor-pointer"
                                    @click="handleShowPopupRejectStatusMarkup">
                                    <span>
                                        {{ $t('labels.reject') }}
                                    </span>
                                    <hi-x-circle-icon
                                        class="w-5 h-5 text-error-600"
                                        aria-hidden="true" />
                                </div>
                            </div>
                        </div>

                        <div
                            v-else-if="
                                !dataFormEdit.statusMarkup && dataFormEdit.statusConfirmMarkup === 0 && !checkPermission(layoutPermissions.partner_confirm_status_markup)
                            "
                            class="flex">
                            <hi-arrow-path-icon
                                class="w-5 h-5"
                                aria-hidden="true" />
                            <span>
                                {{ $t('labels.pendingApproval') }}
                            </span>
                        </div>
                        <div
                            v-else-if="dataFormEdit.statusMarkup && dataFormEdit.statusConfirmMarkup === 1"
                            class="text-green-400 flex">
                            <hi-check-circle-icon
                                class="w-5 h-5"
                                aria-hidden="true" />
                            <span>
                                {{ $t('labels.approved') }}
                            </span>
                        </div>
                        <div
                            v-else-if="!dataFormEdit.statusMarkup && dataFormEdit.statusConfirmMarkup === 2"
                            class="text-error-400 flex">
                            <hi-x-circle-icon
                                class="w-5 h-5"
                                aria-hidden="true" />
                            <span>
                                {{ $t('labels.reject') }}
                            </span>
                        </div>
                    </div>

                    <hts-form-input
                        v-model="dataFormEdit.commission"
                        type="number"
                        :label="$t('labels.commission2')"
                        :color="props.color"
                        name="commission2"
                        prop="commission2" />
                    <hts-select-user
                        v-model="dataFormEdit.curator"
                        v-model:name="dataFormEdit.curatorName"
                        :label="$t('labels.curator')"
                        required
                        prop="curator"
                        group-type="business" />
                    <hts-select-user
                        v-model="dataFormEdit.distribution"
                        v-model:name="dataFormEdit.distributionName"
                        :label="$t('labels.abstemious')"
                        required
                        group-type="distribution"
                        prop="abstemious" />
                </div>

                <div
                    v-if="dataFormEdit.type.includes('PARTNER') && selectCustomerTypeTabs"
                    v-show="selectCustomerTypeTabs === 'PARTNER'">
                    <span class="text-base block px-0 font-medium text-default-500">
                        {{ $t('labels.moocSavingPolicy') }}
                    </span>
                    <div class="pl-10">
                        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                            <hts-form-input
                                v-model="dataFormEdit.cooperatorPolicy.moocSavingPolicy.freeHourNumber"
                                :label="$t('labels.freeHourNumber')"
                                type="number"
                                required
                                :color="props.color"
                                name="keepMoocByHours"
                                prop="keepMoocByHours" />
                            <hts-form-input
                                v-model="dataFormEdit.cooperatorPolicy.moocSavingPolicy.moocKeepHourly"
                                :label="$t('labels.moocKeepHourly')"
                                type="number"
                                required
                                :color="props.color"
                                name="moocKeepHourly"
                                prop="moocKeepHourly" />

                            <hts-form-input
                                v-model="dataFormEdit.cooperatorPolicy.moocSavingPolicy.moocKeepOvernight"
                                :label="$t('labels.moocKeepOvernight')"
                                type="number"
                                required
                                :color="props.color"
                                name="moocKeepOvernight"
                                prop="moocKeepOvernight" />
                            <hts-form-date
                                v-model="dataFormEdit.cooperatorPolicy.moocSavingPolicy.calculatedByHourNextDay"
                                :label="$t('labels.calculatedByHourNextDay')"
                                type="time"
                                required
                                :color="props.color"
                                name="calculatedByHourNextDay"
                                prop="calculatedByHourNextDay" />
                            <hts-form-input
                                v-model="dataFormEdit.cooperatorPolicy.moocSavingPolicy.moocKeepLongTerm"
                                :label="$t('labels.moocKeepLongTerm')"
                                type="number"
                                required
                                :color="props.color"
                                name="moocKeepLongTerm"
                                prop="moocKeepLongTerm" />
                            <hts-form-input
                                v-model="dataFormEdit.cooperatorPolicy.moocSavingPolicy.calculatedFromEvening"
                                :label="$t('labels.moocKeepLongTermCalculatedFromEvening')"
                                type="number"
                                required
                                :color="props.color"
                                name="calculatedFromEvening"
                                prop="calculatedFromEvening" />
                        </div>
                    </div>
                    <span class="text-base block px-0 font-medium text-default-500">
                        {{ $t('labels.holidaySurchargePolicy') }}
                    </span>
                    <div class="pl-10">
                        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                            <hts-form-input
                                v-model="dataFormEdit.cooperatorPolicy.otherSurchargePolicy.towingContainerSunday"
                                :label="$t('labels.towingContainerSunday')"
                                type="number"
                                required
                                :color="props.color"
                                name="towingContainerSunday"
                                prop="towingContainerSunday" />
                            <hts-form-input
                                v-model="dataFormEdit.cooperatorPolicy.otherSurchargePolicy.towingContainerHoliday"
                                :label="$t('labels.towingContainerHoliday')"
                                type="number"
                                required
                                :color="props.color"
                                name="towingContainerHoliday"
                                prop="towingContainerHoliday" />
                        </div>
                    </div>
                    <span class="text-base block px-0 font-medium text-default-500">
                        {{ $t('labels.reeferPluginCharges') }}
                    </span>
                    <div class="pl-10 grid grid-cols-1 sm:grid-cols-2 gap-2">
                        <hts-form-input
                            v-model="dataFormEdit.cooperatorPolicy.reeferPluginCharges.reeferPluginChargesGenerator"
                            :label="$t('labels.reeferPluginChargesGenerator')"
                            type="number"
                            required
                            :color="props.color"
                            name="reeferPluginChargesGenerator"
                            prop="reeferPluginChargesGenerator" />
                    </div>
                </div>
            </hts-card>
        </div>
        <hts-modal
            :show="showConfirmEditCooperator"
            :title="$t('labels.confirmMarkup')"
            type="confirm"
            :content="contentConfirmMarkup"
            @close="showConfirmEditCooperator = false"
            @confirm="handleSubmitFormEdit" />
        <hts-modal
            :show="showConfirmStatusMarkup"
            :title="$t('labels.confirmStatusMarkup')"
            type="confirm"
            :content="$t('labels.contentConfirmStatusMarkup')"
            @close="showConfirmStatusMarkup = false"
            @confirm="confirmStatusMarkup" />
        <hts-modal
            :show="showRejectStatusMarkup"
            :title="$t('labels.confirmStatusMarkup')"
            type="confirm"
            :content="$t('labels.contentRejectStatusMarkup')"
            @hide="showRejectStatusMarkup = false"
            @confirm="rejectStatusMarkup" />
        <hts-modal
            :show="showLocation"
            :title="$t('labels.locationInformation')"
            @hide="showLocation = false">
            <template #custom>
                <hts-map-autocomplete
                    :label="$t('labels.findPosition')"
                    :required="true"
                    :placeholder="$t('labels.nodeModule.search')"
                    @get-place-detail="handleSetPosition" />
                <hts-form-input
                    v-model="dataFormEdit.locationName"
                    :label="$t('labels.location')"
                    :color="props.color"
                    :suffix="false"
                    required
                    disabled
                    name="location"
                    prop="location" />
                <hts-map-node
                    :center-position="dataPostion"
                    center-marker
                    @click="getLocationMap" />
            </template>
        </hts-modal>
        <hts-modal
            :show="showAcceptChangeTypeCooperator"
            :title="titleAcceptChangeTypeCooperator"
            type="confirm"
            :content="detailAcceptChangeTypeCooperator"
            @hide="cancelAcceptChangeTypeCooperator"
            @confirm="handleAcceptChangeTypeCooperator" />
    </hts-router-drawer>
</template>

<script setup lang="ts">
import form, { type IEditCooperator } from '../-components/imports/form'
import layoutPermissions from '@/data/permissions/layout-permissions'
import { checkPermission } from '@/utils/permission-check'

const { $t } = useNuxtApp()

const showConfirmEditCooperator = ref(false)
const showConfirmStatusMarkup = ref(false)
const showRejectStatusMarkup = ref(false)
const emailInviteError = ref('')

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  refreshTables: {
    type: Function,
    default: () => {}
  }
})

const { refreshTables } = toRefs(props)
const emits = defineEmits(['close'])

const openRouterView = ref()

const dataFormEdit = reactive<IEditCooperator>({
  name: '',
  abbreviationName: '',
  email: '',
  taxNumber: '',
  website: '',
  address: '',
  phone: {
    countryCode: '',
    phone: '',
    code: ''
  },
  representation: '',
  office: '',
  fax: '',
  type: [],
  curator: '',
  curatorName: '',
  distribution: '',
  distributionName: '',
  commission: null,
  markup: null,
  isSendMail: false,
  statusMarkup: false,
  statusConfirmMarkup: null,
  locationName: '',
  location: null,
  cooperatorPolicy: {
    moocSavingPolicy: {
      freeHourNumber: 0,
      moocKeepHourly: 0,
      moocKeepOvernight: 0,
      calculatedByHourNextDay: '00:00:00',
      moocKeepLongTerm: 0,
      calculatedFromEvening: 0
    },
    otherSurchargePolicy: {
      towingContainerSunday: 0,
      towingContainerHoliday: 0
    },
    reeferPluginCharges: {
      reeferPluginChargesGenerator: 0
    }
  },
  sentInviteJoinSystem: false
})

const visible = ref(true)
const creating = ref(false)
const loading = ref(false)
const route: any = useRoute()
const cooperatorId = computed(() => useRoute().params.idpartner)

const haveJoinSystem = computed(() => {
  if (dataFormEdit.workspaceCustomer) {
    return true
  }

  if (!dataFormEdit?.sentInviteJoinSystem) {
    return false
  }

  if (!dataFormEdit?.invitationStatus) {
    return false
  }

  return true
})

const closeOverSide = () => {
  if (openRouterView.value) {
    openRouterView.value.handleSubmitClose()
  }
}
const store = $store()

const valueMarkupSetting = computed(() => store.globalSettings.getGlobalSettings.markup)

const visibleSubmit = async () => {
  if (
    dataFormEdit.type.includes('CUSTOMER') &&
    dataFormEdit.markup &&
    dataFormEdit.markup < (valueMarkupSetting.value || 0) &&
    oldMarkup.value !== dataFormEdit.markup
  ) {
    if (!oldTypes.value.includes('CUSTOMER')) {
      showConfirmEditCooperator.value = true
      return
    }
    if (
      typeof dataFormEdit.statusConfirmMarkup !== 'number' ||
      (dataFormEdit.statusMarkup && typeof dataFormEdit.statusConfirmMarkup === 'number' && ![0, 1, 2].includes(dataFormEdit.statusConfirmMarkup)) ||
      (typeof dataFormEdit.statusConfirmMarkup === 'number' && [1, 2].includes(dataFormEdit.statusConfirmMarkup))
    ) {
      showConfirmEditCooperator.value = true
    }
  } else {
    await handleSubmitFormEdit()
  }
}
const handleSubmitFormEdit = async () => {
  try {
    const api = $url.partner['partner-edit']
    creating.value = true
    dataFormEdit.location = dataPostion.value
    const response: any = await $api(api, {
      uriParams: { ID: cooperatorId.value },
      body: dataFormEdit
    })

    const resData: any = response?.data?.value
    creating.value = false
    showConfirmEditCooperator.value = false
    if (resData?.success) {
      if (resData.data.code === 1) {
        emailInviteError.value = $t('labels.emailJoinedSystem')
        return
      }

      if (refreshTables.value && typeof refreshTables.value === 'function') {
        refreshTables.value()
      }
      process.client && $toast().success($t('labels.updateSuccess', { name: $t('labels.partner') }))
      closeOverSide()
      visible.value = false
      getData()
    }
  } catch (e) {
    creating.value = false
    showConfirmEditCooperator.value = false
  }
}

const typeCooperatorDefault = {
  CUSTOMER: false,
  PARTNER: false,
  VENDOR: false
}

const typeCooperator = reactive<{ [key: string]: boolean }>({ ...typeCooperatorDefault })
const getData = () => {
  loading.value = true
  const api = $url.partner['get-detail']
  $api(api, { uriParams: { ID: cooperatorId.value } })
    .then((data: any) => {
      const resData: any = data?.data?.value
      if (resData?.success) {
        loading.value = false
        if (!resData.data.cooperatorPolicy) {
          delete resData.data.cooperatorPolicy
        }
        resData.data.type.forEach((i: string) => {
          if (typeof typeCooperator[i] === 'boolean') {
            typeCooperator[i] = true
          }
        })
        oldTypes.value = [...resData.data.type]
        oldMarkup.value = resData.data.markup
        dataPostion.value = resData.data.location || null
        Object.assign(dataFormEdit, { ...form.initEditCustomer, ...resData.data })
      }
    })
    .catch(() => {
      loading.value = false
    })
}

const handleShowPopupConfirmStatusMarkup = () => {
  showConfirmStatusMarkup.value = true
}
const handleShowPopupRejectStatusMarkup = () => {
  showRejectStatusMarkup.value = true
}

const oldTypes = ref<Array<string>>([])
const oldMarkup = ref<number>(0)

const confirmStatusMarkup = () => {
  const api = $url.partner.confirmStatusMarkup
  $api(api, { uriParams: { ID: cooperatorId.value } })
    .then((data: any) => {
      const resData: any = data?.data?.value
      if (resData?.success) {
        process.client && $toast().success($t('labels.updateSuccess', { name: $t('labels.partner') }))
        showConfirmStatusMarkup.value = false
        getData()
      }
    })
    .catch(() => {})
}

const rejectStatusMarkup = () => {
  const api = $url.partner.rejectStatusMarkup
  $api(api, { uriParams: { ID: cooperatorId.value } })
    .then((data: any) => {
      const resData: any = data?.data?.value
      if (resData?.success) {
        process.client && $toast().success($t('labels.updateSuccess', { name: $t('labels.partner') }))
        showRejectStatusMarkup.value = false
        getData()
      }
    })
    .catch(() => {})
}

const showLocation = ref(false)
const openModalLocation = () => {
  showLocation.value = true
}

const dataPostion = ref<{ lat: number; lng: number } | null>({
  lat: 10.7561542,
  lng: 106.6896784
})

const handleSetPosition = (data: any) => {
  dataFormEdit.locationName = data.formatted_address || ''
  dataPostion.value = {
    lat: data.geometry.location.lat(),
    lng: data.geometry.location.lng()
  }
}

const getLocationMap = (data: any) => {
  const geocoder = new google.maps.Geocoder()
  geocoder.geocode({ location: data }).then((result) => {
    const { results } = result
    dataFormEdit.locationName = results[0].formatted_address
    dataPostion.value = {
      lat: results[0].geometry.location.lat(),
      lng: results[0].geometry.location.lng()
    }
  })
}

const showAcceptChangeTypeCooperator = ref(false)
const titleAcceptChangeTypeCooperator = ref('')
const detailAcceptChangeTypeCooperator = ref('')
const handleAcceptChangeTypeCooperator: any = ref()
const cancelAcceptChangeTypeCooperator: any = ref()

watch(
  () => ({ ...dataFormEdit.type }),
  (newVal, oldVal) => {
    if (Object.values(oldVal).includes('CUSTOMER') && !Object.values(newVal).includes('CUSTOMER')) {
      titleAcceptChangeTypeCooperator.value = $t('labels.titleAcceptChangeTypeCustomer')
      detailAcceptChangeTypeCooperator.value = $t('labels.detailAcceptChangeTypeCustomer')
      handleAcceptChangeTypeCooperator.value = () => handleChangeCheckboxCooperatorTypeCustomer(false)
      cancelAcceptChangeTypeCooperator.value = () => cancelChangeTypeCooperator('CUSTOMER')
      showAcceptChangeTypeCooperator.value = true
      return
    }

    if (Object.values(oldVal).includes('PARTNER') && !Object.values(newVal).includes('PARTNER')) {
      titleAcceptChangeTypeCooperator.value = $t('labels.titleAcceptChangeTypePartner')
      detailAcceptChangeTypeCooperator.value = $t('labels.detailAcceptChangeTypePartner')
      handleAcceptChangeTypeCooperator.value = () => handleChangeCheckboxCooperatorTypePartner(false)
      cancelAcceptChangeTypeCooperator.value = () => cancelChangeTypeCooperator('PARTNER')
      showAcceptChangeTypeCooperator.value = true
    }
  },
  { deep: true }
)

const cancelChangeTypeCooperator = (type: string) => {
  if (dataFormEdit.type.includes(type)) {
    return
  }

  if (type === 'CUSTOMER') {
    dataFormEdit.type.push(type)
  }

  if (type === 'PARTNER') {
    dataFormEdit.type.push(type)
  }

  showAcceptChangeTypeCooperator.value = false
}

const handleChangeCheckboxCooperatorTypeCustomer = (val: boolean) => {
  if (typeof val === 'boolean') {
    showAcceptChangeTypeCooperator.value = false
    if (val) {
      dataFormEdit.type.push('CUSTOMER')
      if (!oldTypes.value.includes('CUSTOMER') && !dataFormEdit.markup) {
        const valueMarkupSetting = store.globalSettings.getGlobalSettings.markup
        dataFormEdit.markup = valueMarkupSetting
      }
    }
    if (!val) {
      $lodash.remove(dataFormEdit.type, (i) => {
        return i === 'CUSTOMER'
      })
      dataFormEdit.markup = null
      dataFormEdit.commission = null
      dataFormEdit.curator = ''
      dataFormEdit.curatorName = ''
      dataFormEdit.distribution = ''
      dataFormEdit.distributionName = ''
    }
  }
}
const handleChangeCheckboxCooperatorTypePartner = (val: boolean) => {
  if (typeof val === 'boolean') {
    showAcceptChangeTypeCooperator.value = false
    if (val) {
      dataFormEdit.type.push('PARTNER')
    }
    if (!val) {
      $lodash.remove(dataFormEdit.type, (i) => {
        return i === 'PARTNER'
      })
      dataFormEdit.cooperatorPolicy = {
        moocSavingPolicy: {
          freeHourNumber: 0,
          moocKeepHourly: 0,
          moocKeepOvernight: 0,
          calculatedByHourNextDay: '00:00:00',
          moocKeepLongTerm: 0,
          calculatedFromEvening: 0
        },
        otherSurchargePolicy: {
          towingContainerSunday: 0,
          towingContainerHoliday: 0
        },
        reeferPluginCharges: {
          reeferPluginChargesGenerator: 0
        }
      }
    }
  }
}

const selectCooperatorTypes = [
  {
    label: $t('labels.customer'),
    value: 'CUSTOMER'
  },
  {
    label: $t('labels.partner'),
    value: 'PARTNER'
  },
  {
    label: $t('labels.vendor'),
    value: 'VENDOR'
  }
]

const ruleAddCustomer = computed(() => {
  const result = { ...form.rulesEditCustomer }
  if (dataFormEdit.locationName && dataFormEdit.locationName.search('Việt Nam') !== -1) {
    // result.taxNumber = 'required|regexTaxNumber'
    result.taxNumber = 'required' // for intergate
  }
  return result
})

const customerTypeTabs = computed(() => {
  const tabs: any = []
  const keyTypes: any = []
  if (dataFormEdit.type.includes('CUSTOMER')) {
    tabs.push({
      id: 'CUSTOMER',
      label: $t('labels.customer')
    })
    keyTypes.push('CUSTOMER')
  }

  if (dataFormEdit.type.includes('PARTNER')) {
    tabs.push({
      id: 'PARTNER',
      label: $t('labels.partner')
    })
    keyTypes.push('PARTNER')
  }

  if (!keyTypes.length) {
    selectCustomerTypeTabs.value = ''
  } else if (!keyTypes.includes(selectCustomerTypeTabs.value)) {
    selectCustomerTypeTabs.value = keyTypes[0]
  }

  return tabs
})

const selectCustomerTypeTabs = ref('')

const setDefaultDataPostionByAddress = $lodash.debounce(() => {
  const geocoder = new google.maps.Geocoder()
  const address = dataFormEdit.address
  geocoder.geocode({ address }, function (results, status) {
    if (status === 'OK') {
      if (results && results.length > 0) {
        const location = results[0].geometry.location
        dataPostion.value = {
          lat: location.lat(),
          lng: location.lng()
        }
        dataFormEdit.locationName = results[0].formatted_address
      }
    }
  })
}, 500)

const contentConfirmMarkup = computed(() => {
  //  label confirm markup
  if (checkPermission(layoutPermissions.partner_confirm_status_markup)) {
    return `Markup được nhập có giá trị nhỏ hơn giá trị được cài đặt cho toàn hệ thống ${valueMarkupSetting.value}%. Bạn có muốn tiếp tục?`
  } else {
    return `Markup được nhập có giá trị nhỏ hơn giá trị được cài đặt cho toàn hệ thống ${valueMarkupSetting.value}%. Vui lòng chờ phê duyệt từ bộ phận quản lý.`
  }
})

const tooltipMarkup = computed(() => {
  return `Markup được nhập có giá trị nhỏ hơn giá trị được cài đặt cho toàn hệ thống ${valueMarkupSetting.value}%. Vui lòng xem xét phê duyệt/từ chối giá trị markup này!`
})
</script>
